const CONTROLLER = '/auth';
const PATHS = {
  REGISTER: '/register',
  LOGIN: '/login',
  VALIDATE_MAIL: '/validate-mail',

  REFRESH: '/refresh',
  LOGOUT: '/logout',
  SWITCH: '/switch',
  RESEND_VERIFICATION_MAIL: '/resend-verification-mail',
  GET_ABILITIES: '/abilities',
  DELETE_ACCOUNT: '/me',
};

const AuthApiRoutes = {
  CONTROLLER,
  PATHS,
  NAMES: Object.fromEntries(
    (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k]),
  ) as {
    [K in keyof typeof PATHS]: K;
  },
  REGISTER: `${CONTROLLER}${PATHS.REGISTER}`,
  LOGIN: `${CONTROLLER}${PATHS.LOGIN}`,
  VALIDATE_MAIL: (token: string | undefined) =>
    `${CONTROLLER}${PATHS.VALIDATE_MAIL}?token=${String(token)}`,

  REFRESH: `${CONTROLLER}${PATHS.REFRESH}`,
  LOGOUT: `${CONTROLLER}${PATHS.LOGOUT}`,
  SWITCH: `${CONTROLLER}${PATHS.SWITCH}`,
  RESEND_VERIFICATION_MAIL: `${CONTROLLER}${PATHS.RESEND_VERIFICATION_MAIL}`,
  GET_ABILITIES: `${CONTROLLER}${PATHS.GET_ABILITIES}`,
  DELETE_ACCOUNT: `${PATHS.DELETE_ACCOUNT}`,
};

export default AuthApiRoutes;
